import { GUID } from '@/core';
import { ProductCode } from '@/store';

export const mockProductCode = 'aptis' as ProductCode;
export const mockProductId = '099038BD-1151-4D0D-930C-DEF02CA7FAD2' as GUID;
export const mockProductSettings = { productCode: mockProductCode, enrollmentQuantityLimitPerOrder: 1, supportedFeatures: [] };
